module.exports = __webpack_public_path__ + "img/bigpack-badge.b2e1abf0.svg";